/**
 * 解析 quiz 可选 query `returnUrl`（encode 后的 hash 内路径），用于提交成功后 router.replace。
 * 拒绝开放重定向：仅允许以 `/` 开头的站内路径，可选 `?query`；不支持外链与 `//` 协议相对 URL。
 *
 * @param {string|null|undefined} raw
 * @returns {{ path: string, query?: Record<string, string> }|null}
 */
export function resolveQuizReturnLocation(raw) {
  const location = resolveQuizReturnLocationInner(raw)
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.info('[quiz][returnUrl] resolve', {
      raw,
      location,
      decodedPreview: typeof raw === 'string' ? safeDecodePreview(raw) : null
    })
  }
  return location
}

function safeDecodePreview(s) {
  try {
    return decodeURIComponent(s.trim())
  } catch {
    return '(decode error)'
  }
}

function resolveQuizReturnLocationInner(raw) {
  if (raw == null || typeof raw !== 'string') return null
  const trimmed = raw.trim()
  if (!trimmed) return null
  let decoded
  try {
    decoded = decodeURIComponent(trimmed)
  } catch {
    return null
  }
  if (decoded.length > 2048) return null
  if (decoded.startsWith('//')) return null
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(decoded)) return null
  if (!decoded.startsWith('/')) return null
  const qIdx = decoded.indexOf('?')
  const path = qIdx >= 0 ? decoded.slice(0, qIdx) : decoded
  if (path.includes('#')) return null
  if (path.includes('..')) return null

  if (qIdx < 0) {
    return { path }
  }
  const qs = decoded.slice(qIdx + 1)
  const query = {}
  try {
    const sp = new URLSearchParams(qs)
    sp.forEach((v, k) => {
      query[k] = v
    })
  } catch {
    return null
  }
  return Object.keys(query).length ? { path, query } : { path }
}
